/** Render an alert's `detail` jsonb into a short human line, per alert kind. */
export function formatAlertDetail(kind: string, detail: unknown): string {
	if (detail == null) return "";
	if (typeof detail === "string") return detail;
	if (typeof detail !== "object") return String(detail);
	const d = detail as Record<string, unknown>;
	const arr = (x: unknown): string[] => (Array.isArray(x) ? (x as string[]) : []);
	const obj = (x: unknown): Record<string, unknown> => (x && typeof x === "object" ? (x as Record<string, unknown>) : {});

	switch (kind) {
		case "infra_change": {
			const ns = obj(d.ns);
			const ip = obj(d.ip);
			const parts: string[] = [];
			if (arr(ns.added).length) parts.push(`NS +${arr(ns.added).join(", ")}`);
			if (arr(ns.removed).length) parts.push(`NS −${arr(ns.removed).join(", ")}`);
			if (arr(ip.added).length) parts.push(`IP +${arr(ip.added).join(", ")}`);
			if (arr(ip.removed).length) parts.push(`IP −${arr(ip.removed).join(", ")}`);
			return parts.join(" · ");
		}
		case "expiring":
			return d.expires ? `expires ${new Date(String(d.expires)).toLocaleDateString()}` : "";
		case "new_cert":
			return d.new_certs ? `${d.new_certs} new cert(s)` : "";
		case "blacklisted":
		case "source_unavailable":
			return `${d.previous ? `${d.previous} → ` : ""}${d.status ?? ""}${d.response ? ` (${d.response})` : ""}`;
		case "delisted":
			return d.previous ? `was ${d.previous}` : "";
		case "source_down":
			return `no verdicts ${d.consecutive_errors ?? "?"} sweeps in a row${d.last_ok_at ? ` (last ok ${new Date(String(d.last_ok_at)).toLocaleString()})` : ""}`;
		default:
			return JSON.stringify(d).slice(0, 200);
	}
}
